<div class="game-categories-selector" *ngIf="organizationData && hasGlobalTrainingFirstResponse">
  <div class="game-categories-selector__grid">
    <brt-game-category-preview
      *ngFor="let organizationCategoryData of organizationData.items"
      [data]="organizationCategoryData"
      [mode]="mode"
      [gameId]="gameId"
      (select-changed)="onSelectChange($event)"
      [isGlobalTraining]="isGlobalTraining"
      [selected]="isSelected(organizationCategoryData.categoryData.id)"></brt-game-category-preview>
  </div>
</div>
